import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ResultItem } from 'src/app/apiAndObjects/objects/resultItems/resultItem.interface';
@Injectable({
  providedIn: 'root',
})
export class EVResultsService {
  private readonly resultsData = new Subject<Array<ResultItem>>();

  public setResults(data: Array<ResultItem>): void {
    this.resultsData.next(data);
  }
  public watchResults(): Observable<Array<ResultItem>> {
    return this.resultsData.asObservable();
  }
}
